import { Modal as ModalModule, UI, Utils } from 'common';
import React, { useContext } from 'react';

const { ModalContext, Modal, ModalButtonActionType, StatusModal } = ModalModule;
const { withLayoutAndModalContexts } = Utils;
const { Typography } = UI;

const ResetPasswordModal = ({ modalId, data }) => {
	const { EmailAddress, FullName, callback, status } = data;
	const { closeModal } = useContext(ModalContext);

	const onCloseModal = () => {
		closeModal(modalId);
	};

	const onContinueButtonClick = async () => {
		await callback();
		onCloseModal();
	};

	const primaryButton = {
		type: ModalButtonActionType.Confirm,
		text: 'Continue',
		onClick: onContinueButtonClick,
		dataqa: 'reset-password-continue-button',
	};

	const secondaryButton = {
		type: ModalButtonActionType.Cancel,
		text: 'Cancel',
		onClick: onCloseModal,
		dataqa: 'reset-password-cancel-button',
	};

	return status ? (
		<StatusModal
			modalId={modalId}
			header="Password Reset Link Sent"
			description={
				<>
					The password reset link has been sent to <b>{EmailAddress}</b>.
				</>
			}
			onClose={onCloseModal}
			iconType="success"
		/>
	) : (
		<Modal
			modalId={modalId}
			className="account-users reset-password-modal"
			header="Reset Password"
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
			size="small"
		>
			<div className="p-grid">
				<div className="p-col-12">
					<Typography.P>
						Do you wish to reset the password for <b>{FullName}</b>?
					</Typography.P>
				</div>
				<div className="p-col-12">
					<Typography.P>
						Password recovery instructions will be sent to their email:{' '}
						<b>{EmailAddress}</b>
					</Typography.P>
				</div>
			</div>
		</Modal>
	);
};

export default withLayoutAndModalContexts(ResetPasswordModal);
